import { render, staticRenderFns } from "./DeleteTypeEntreprise.vue?vue&type=template&id=2ad7584e&"
import script from "./DeleteTypeEntreprise.vue?vue&type=script&lang=js&"
export * from "./DeleteTypeEntreprise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports